const storageFilters = {
  name: true,
  nps: true,
  csat: true,
};

const getDataFromStorage = (storagedData, initialData) => {
  for (const key in storagedData) {
    initialData[key] = storagedData[key];
  }
  return initialData;
};

//const initialState = storageFilters;
const initialState = localStorage.getItem(
  "filters_quality_agent_negotiations_columns"
)
  ? getDataFromStorage(
      JSON.parse(
        localStorage.getItem("filters_quality_agent_negotiations_columns")
      ),
      storageFilters
    )
  : storageFilters;

const columnsNegotiationsAgent = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_COLUMNS_NEGOTIATIONS_QUALITY_AGENT":
      return {
        name: action.name,
        nps: action.nps,
        csat: action.csat,
      };
    default:
      return state;
  }
};

export default columnsNegotiationsAgent;
